const attrPattern = /([\w\-_]+)\s*(:?=\s*((?:(['"])(.*?)\4)|[^\s>]+))?/ms

export function extend(tags, options) {
    options = {
        ...options
    }
    return source => parse(source, tags, options)
}

export function parse(source, tags, options) {
    tags = Array.isArray(tags) ? tags : [tags]
    tags = tags.map(tag => tag === '*' ? '[^/\\s>]+' : tag)
    options = {
        tagKey: '<',
        ...options,
    }

    const pattern = new RegExp(`(<(?:${tags.join('|')})(?:\\s+(.*?))?>)`, 'igms')

    let matchs = stripComments(source).match(pattern)
    return (matchs || [])
        .map(tag => {
            return parseAttrs(tag, options.tagKey)
        })
        .filter(x => x)
}

export function parseTag(source, tags) {
    tags = Array.isArray(tags) ? tags : [tags]
    tags = tags.map(tag => tag === '*' ? '[^/\\s>]+' : tag)

    const pattern = new RegExp(`<(${tags.join('|')})\\b[^>]*>([\\s\\S]*?)<\\/(${tags.join('|')})>`, 'igm');

    return [...source.matchAll(pattern)]?.map((tag) => {
        let output = {}
        output = !tag?.[2] ? parseAttrs(tag, 'tag') : {
            children: tag?.[2],
            tag: tag?.[1]
        }

        return output
    })
}

export function parseAttrs(htmlTagText, tagKey = '<') {
    const attrs = {}

    const matchPattern = new RegExp(attrPattern, 'gims')
    let match = matchPattern.exec(htmlTagText)
    if (!match) {
        return
    }
    attrs[tagKey] = match[1]

    while ((match = matchPattern.exec(htmlTagText)) !== null) {
        const key = match[1]
        attrs[key] = match[5] !== undefined ?
            match[5] :
            (match[3] !== undefined ?
                match[3] :
                true)
    }
    return attrs
}

export function stripComments(html) {
    return html.replace(/<!--[\s\S]*?(?:-->)/gms, '')
}
